import { Typography } from 'antd'

const { Title, Paragraph } = Typography

const LegalNotice = () => {
  return (
    <>
      <Title level={2}>MENTIONS LEGALES</Title>
      <Paragraph>Contenu à rédiger</Paragraph>
    </>
  )
}

export default LegalNotice
